<template>
  <fieldset class="table-dynamic bs3-row-reset">
    <legend>
      <i class="fa-light fa-scroll"></i> <span>{{pDictionary['dictionary.history']}}</span>
      <a :href="pUrls['createHistoryEvent'] + '?dataForm.historyRef.id=' + pHistoryId + urlParams"
         class="btn btn-default btn-sm bs3-margin-bottom3 bs3-margin-left ajax-support show-waiting"
         data-ajax-support-csv="#ajaxModuleForm,#popoverHistory" v-if="pCreateCustomEventEnabled"><i class="fa-light fa-plus"></i> {{pDictionary['dictionary.history.event.create']}}</a>
      <a :href="pUrls['listHistoryEvents'] + '?reset=true&export=xls&dataListInput.historyIds=' + pHistoryId"
         class="btn btn-default btn-sm right" data-toggle="tooltip" title="" data-original-title="Export to Excel" v-if="pExportEnabled">
        <i class="fa-light fa-file-excel"></i>
      </a>
    </legend>
    <div id="history-list-container" :class="['bs3-padding-top-reset',  {'content-scrollable' : pScrollEnabled}]">
      <div id="history-list" class="" ref="historyList">
        <div v-if="loading" class="loading bs3-margin-bottom"><i class="fa-light fa-spinner fa-spin" aria-hidden="true"></i> {{pDictionary['dictionary.general.loading']}}</div>
        <div v-else-if="!historyEvents.length" class="emptyOrNull bs3-margin-bottom">{{pDictionary['dictionary.general.none']}}</div>
        <history-event v-for="historyEvent in historyEvents" :key="historyEvent.id"
                       :p-history-event="historyEvent"
                       :p-dictionary="pDictionary"
                       :p-urls="pUrls"
                      :p-src="pSrc"
                      :p-src-id="pSrcId"/>
      </div>
    </div>
  </fieldset>
</template>

<script>
import HistoryEvent from "@/components/common/history/HistoryEvent";
import BaseMixin from "@/mixins/base-mixin";

export default {
  name: "HistorySection",
  components: {
    HistoryEvent
  },
   mixins: [BaseMixin],
  props: {
    pHistoryId: Number,
    pDataListInput: {
      type: Object,
      default: function(){
        return {historyId: this.pHistoryId};
      }
    },
    pScrollEnabled: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    pCreateCustomEventEnabled: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    pExportEnabled: {
      type: Boolean,
      default: function() {
        return true;
      }
    }
  },
  data: function () {
    return {
       loading: false,
       historyEvents: []
    }
  },
  methods: {
     getHistoryEvents: function() {
        let _component = this;
        _component.loading = true;
        $.ajax({
                  type: "POST",
                  url: '/mediaplan/app/endpoints/json-api/history/events',
                  data: JSON.stringify(_component.pDataListInput),
                  headers: {
                     'Accept': 'application/json',
                     'Content-Type': 'application/json'
                  }
               }).done(function (dataList) {
           _component.historyEvents = dataList.items
           _component.loading = false;
        });
     }
  },
   computed: {
      urlParams: function () {
         let urlParams = "";
         if(this.pSrc)
         {
            urlParams += "&src=" + this.pSrc;
         }
         if(this.pSrcId)
         {
            urlParams += "&srcId=" + this.pSrcId;
         }
         return urlParams;
      }
   },
  mounted: function () {
    this.getHistoryEvents();
  }
}
</script>

<style scoped>

</style>